
import { computed, defineComponent, ref, SetupContext, watch, onBeforeUnmount } from 'vue';

export default defineComponent({
  name: 'TToast',
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: [String, Array],
      default: '',
    },
    timeout: {
      type: Number,
      default: 3000,
      validator: (value: number) => value > 1000,
    },
  },
  emits: ['update:modelValue'],
  setup(props, context: SetupContext) {
    let timerId: any = 0;
    /** 组件的className前辍 */
    const prefixCls = ref('t-toast');
    /** 模板依赖的className */
    const getClasses = computed(() => {
      return {
        wrap: [prefixCls.value],
        title: [`${prefixCls.value}-title`],
        bd: [`${prefixCls.value}-bd`],
      };
    });
    /** 定义关闭toast的事件 */
    const hide = () => {
      clearTimeout(timerId);
      context.emit('update:modelValue', false);
    };
    /** 定义显示toast的事件 */
    const show = () => {
      clearTimeout(timerId);
      context.emit('update:modelValue', true);
      timerId = setTimeout(() => context.emit('update:modelValue', false), props.timeout);
    };
    /** 监听modelValue, 做组修的内部的显示、隐藏逻辑 */
    const stopWatch = watch(
      () => props.modelValue,
      (newValue, oldValue) => (newValue ? show() : hide()),
    );
    onBeforeUnmount(() => {
      hide();
      stopWatch();
    });
    return { prefixCls, getClasses, show, hide };
  },
});
